<template>
  <div class="card">
    <div class="card-body p-0">
      <cardHead :title="'Queues'"
        :buttons="[
          {
            title: 'Refresh Queues',
            icon: 'fa fa-sync-alt',
            emit: 'get',
          },
        ]"
        @get="get"></cardHead>
      <dataTable
        v-if="data == null?[]:data"
        :name="'TechnicalsQueues'"
        ref="agGrid"
        :data="data"
        :columnDefs="columnDefs"
        @remove="remove"
      ></dataTable>
    </div>
  </div>
</template>

<script>
export default {
  name: "Queues",
  data() {
    return {
      data: null,
      timer: null,
      columnDefs: [
        {
          headerName: "Name",
          field: "Name",
          enableRowGroup: true,
          floatingFilter: true,
          filter: "agTextColumnFilter",
          flex: 1,
          minWidth: 140,
        },
        {
          headerName: "MessageCount",
          field: "MessageCount",
          enableRowGroup: true,
          floatingFilter: true,
          filter: "agTextColumnFilter",
          width: 140,
        },
        {
          headerName: "ConsumerCount",
          field: "ConsumerCount",
          enableRowGroup: true,
          floatingFilter: true,
          filter: "agTextColumnFilter",
          width: 150,
        },
        {
          headerName: "Duplicatable",
          field: "Duplicatable",
          enableRowGroup: true,
          floatingFilter: false,
          filter: false,
          width: 130,
          cellRenderer: this.$CheckCellRenderer,
        },
        {
          headerName: "",
          type: "action",
          width: 40,
          buttons: [
            {
              classes: "btn btn-xs waves-effect waves-light btn-danger",
              text: '<i class="fas fa-trash-alt"></i>',
              emit: "remove",
            },
          ]
        },
      ],
    };
  },
  created() {
    this.get();
  },
  methods: {
    get() {
      this.data = null;
      this.$appAxiosAdmin.get(`Queues`).then((response) => {
        this.data = response.data.sort((x, y) => {
          return y.MessageCount - x.MessageCount;
        });
      });
    },
    remove(item) {
      this.$appAxiosAdmin
        .get(`Queues/Purge/` + item.Name)
        .then(() => {
          this.$swal({
            icon: "success",
            title: "Success",
            text: "Successfully purged the queue.",
            timer: 2000,
            confirmButtonText: "Okey",
          });
          this.get();
        })
        .catch((err) => {
          this.$isError(err);
        });
    },
  },
  unmounted() {
    clearInterval(this.timer);
  },
};
</script>
